/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParsedFieldBoolean
 */
export interface ParsedFieldBoolean {
    /**
     * 
     * @type {boolean}
     * @memberof ParsedFieldBoolean
     */
    value?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ParsedFieldBoolean
     */
    hasParseErrors?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParsedFieldBoolean
     */
    parseErrors?: Array<string>;
}

/**
 * Check if a given object implements the ParsedFieldBoolean interface.
 */
export function instanceOfParsedFieldBoolean(value: object): value is ParsedFieldBoolean {
    return true;
}

export function ParsedFieldBooleanFromJSON(json: any): ParsedFieldBoolean {
    return ParsedFieldBooleanFromJSONTyped(json, false);
}

export function ParsedFieldBooleanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParsedFieldBoolean {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'hasParseErrors': json['hasParseErrors'] == null ? undefined : json['hasParseErrors'],
        'parseErrors': json['parseErrors'] == null ? undefined : json['parseErrors'],
    };
}

export function ParsedFieldBooleanToJSON(value?: ParsedFieldBoolean | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'hasParseErrors': value['hasParseErrors'],
        'parseErrors': value['parseErrors'],
    };
}

